import { createWsConnectionSlice } from '@skynet/data-ws-core';
import { authActions } from './actions';

const wsAuthSlice = createWsConnectionSlice('wsAuth', authActions);

export type WsAuthState = ReturnType<typeof wsAuthSlice.getInitialState>;

export const wsAuthActions = wsAuthSlice.actions;

export default wsAuthSlice.reducer;
